import { IconStarFilled, IconStar } from '@tabler/icons-react';

export default function Stars({ value = 0, max = 5, size = 18 }) {
    return (
        <span className="inline-flex items-center gap-0.5">
            {Array.from({ length: max }, (_, i) => (i < value
                ? <IconStarFilled key={i} size={size} className="text-amber-400" />
                : <IconStar key={i} size={size} className="text-[#DED8D1] dark:text-zinc-700" stroke={1.6} />
            ))}
        </span>
    );
}
